import React from 'react'
import axios from 'axios'
import {
  Breadcrumb,
  BreadcrumbItem,
  Button, Card,
  CardBody,
  CardHeader, Col,
  Form,
  FormGroup,
  Input, InputGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader,
  Row,
  Table
} from "reactstrap";
import { Link } from 'react-router-dom'
import {confirmAlert} from "react-confirm-alert";
import jwt from "jsonwebtoken";
import Pagination from "react-js-pagination";
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment';
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select'
import {USER_ROLE} from "../../constants";

let timerId;

class Cash extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        total: 0,
        list: [],
        size: 20,
        from: 0,
        page: 1
      },
      modalToggle: false,
      modalEditToggle: false,
      currUser: {},
      listCustomer: [],
      selectedCustomer: {
        id: '',
        name: '',
        khCode: '',
        phone: '',
        address: ''
      },
      createCash: {
        customerName: "",
        customerId: "",
        customerAddress: "",
        customerPhone: "",
        packageCode: "",
        amount: "",
        statusType: "Chưa thu",
        location: "HCM",
        note: "",
      },
      editCash: {
        customerName: "",
        customerId: "",
        customerAddress: "",
        customerPhone: "",
        packageCode: "",
        amount: "",
        statusType: "Chưa thu",
        location: "HCM",
        note: "",
      },
      loading: false,
      date: new Date(),
      search: '',
      qStatus: '',
      searchBy: 'cashId',
      location: '',
      locationOption: {
        HCM: "HCM",
        HN: 'HN',
        ĐN: 'ĐN'
      },
      isMyCash: false,
    }
    
    this.onDeleteCash = this.onDeleteCash.bind(this)
    this.openEditModal = this.openEditModal.bind(this)
    this.onEditCash = this.onEditCash.bind(this)
    this.onCreateCash = this.onCreateCash.bind(this);
    this.onEditCashChange = this.onEditCashChange.bind(this);
    this.onCreateCashChange = this.onCreateCashChange.bind(this);
    this.onSelectedCustomer = this.onSelectedCustomer.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSelectedEditCustomer = this.onSelectedEditCustomer.bind(this);
    this.handleDatetoSelect = this.handleDatetoSelect.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.toggle = this.toggle.bind(this);
    this.searchStatus = this.searchStatus.bind(this);
    this.searchBy = this.searchBy.bind(this);
    this.searchBylocation = this.searchBylocation.bind(this);
    this.onMyCashChange = this.onMyCashChange.bind(this);
  }

  async componentDidMount() {
    let token = localStorage.getItem('id_token')
    let currUser = jwt.decode(token)
    await this.setState({ currUser, createCash: {...this.state.createCash, owner: currUser.displayName} })
    await this.getAllCash()
    await this.getListCustomer()
  }

  async onCreateCash(e) {
    e.preventDefault();
    try {
      const { createCash } = this.state
      let message = ''
      if (!createCash.customerId) {
        message = 'chọn khách hàng'
      } else if (!createCash.customerName) {
        message = 'nhập tên khách hàng'
      } else if (!createCash.customerAddress) {
        message = 'nhập địa chỉ khách hàng'
      } else if (!createCash.customerPhone) {
        message = 'nhập số điện thoại khách hàng'
      } else if (!createCash.packageCode) {
        message = 'nhập mã kiện hàng'
      } else if (!createCash.amount) {
        message = 'nhập số tiền thu'
      }

      if (message) {
        toast.error('Vui lòng ' + message)
        return
      }

      await axios.post('/create-cash', {...createCash, date: this.state.date})
      this.setState((prevState) => ({ modalToggle: !prevState.modalToggle }));
      await this.getAllCash()
      toast.success('Tạo thông tin thu tiền thành công!')
    } catch (err) {
      toast.error('Đã có lỗi xảy ra ', err.error);
      return
    }
  }

  async onEditCash(e) {
    e.preventDefault();
    const { editCash } = this.state
    let message = ''
    
    if (!editCash.customerId) {
      message = 'chọn khách hàng'
    } else if (!editCash.customerName) {
      message = 'nhập tên khách hàng'
    } else if (!editCash.customerAddress) {
      message = 'nhập địa chỉ khách hàng'
    } else if (!editCash.customerPhone) {
      message = 'nhập số điện thoại khách hàng'
    } else if (!editCash.packageCode) {
      message = 'nhập mã kiện hàng'
    } else if (!editCash.amount) {
      message = 'nhập số tiền thu'
    }

    if (message) {
      toast.error('Vui lòng ' + message)
      return
    }
    
    try {
      const updateData = {...editCash, date: this.state.date}
      if (editCash.statusType === 'Đã thu' && !editCash.collectedAt) {
        updateData.collectedAt = new Date()
      }
      
      await axios.post(`/update-cash/${editCash.id}`, updateData)
      this.setState((prevState) => ({ modalEditToggle: !prevState.modalEditToggle }));
      await this.getAllCash()
      toast.success('Cập nhật thông tin thu tiền thành công!')
    } catch (err) {
      toast.error('Đã có lỗi xảy ra');
      return
    }
  }

  toggle() {
    this.setState((prevState, props) => ({ modalToggle: !prevState.modalToggle }));
  }

  openEditModal(obj) {
    this.setState({editCash: obj, date: moment(obj.date).subtract(7,'h')})
    this.setState((prevState, props) => ({ modalEditToggle: !prevState.modalEditToggle }));
  }

  onMyCashChange(e) {
    this.setState({isMyCash: e.target.checked}, () => {
      this.getAllCash()
    })
  }

  onCreateCashChange(e) {
    const { name, value } = e.target;
    let createCashInfo = this.state.createCash
    createCashInfo[name] = value
    this.setState({ createCash: createCashInfo })
  }

  onEditCashChange(e) {
    const { name, value } = e.target;
    let editCashInfo = this.state.editCash
    editCashInfo[name] = value
    this.setState({ editCash: editCashInfo })
  }

  formatNumber (num) {
    if (num) {
      return new Intl.NumberFormat().format(num)
    }
    return num
  }

  async onDeleteCash(id) {
    try {
      const self = this
      confirmAlert({
        title: "Delete Confirmation",
        message: "Are you sure to delete this Cash record?",
        buttons: [
          {
            label: "Yes",
            onClick: async() => {
              const res = await axios.get(`/delete-cash/${id}`)
              console.log(res)
              await self.getAllCash()
              toast.success('Xóa thành công!')
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    } catch (e) {
      console.error(e)
    }
  }

  onSelectedCustomer = (customer) => {
    console.log('change ', customer)
    if (customer) {
      const { id } = customer
      const temp = this.state.listCustomer.filter(e => e.id == id)?.[0]
      if (temp) {
        let createCashInfo = this.state.createCash
        createCashInfo['customerName'] = temp.name
        createCashInfo['customerId'] = temp.id
        createCashInfo['customerAddress'] = temp.address
        createCashInfo['customerPhone'] = temp.phone
        this.setState({ selectedCustomer: temp, createCash: createCashInfo })
      }
    }
  }

  handleInputChange(e) {
    const inputValue = e;
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      console.log(inputValue);
      this.getListCustomer({ search: inputValue });
    }, 500);
  }

  onSelectedEditCustomer = (customer) => {
    console.log('change ', customer)
    if (customer) {
      const { id } = customer
      const temp = this.state.listCustomer.filter(e => e.id == id)?.[0]
      if (temp) {
        let editCashInfo = this.state.editCash
        editCashInfo['customerName'] = temp.name
        editCashInfo['customerId'] = temp.id
        editCashInfo['customerAddress'] = temp.address
        editCashInfo['customerPhone'] = temp.phone
        this.setState({ selectedCustomer: temp, editCash: editCashInfo })
      }
    }
  }

  async getAllCash(params = {}) {
    try {
      const { searchBy, search = '', data } = this.state
      this.setState({loading: true})
      let res
      params.page = params.page || data?.page
      let url = `/get-all-cash?page=${params.page || 1}&search=${search}&status=${this.state.qStatus}`
      
      if (searchBy === 'packageCode') {
        url += `&searchBy=${searchBy}`
      }
      if (this.state.location) {
        url +=`&location=${this.state.location}`
      }

      if (this.state.currUser.role === USER_ROLE.MANAGER && this.state.currUser.location) {
        url +=`&location=${this.state.currUser.location}`
        const options = {
          [this.state.currUser.location]: this.state.currUser.location
        }
        this.setState({locationOption: options})
      }
      
      res = await axios.get(url)
      if (res && res.data) {
        console.log(res.data)
        this.setState({data: res.data})
      }
      this.setState({loading: false})
    } catch (e) {
      console.error(e)
      this.setState({loading: false})
    }
  }

  async getListCustomer(params = {search: ''}) {
    try {
      let url = `/get-all-customer?page=${params.page || 1}&size=10&search=${params.search}`
      if (this.state.currUser.role === USER_ROLE.SALER || this.state.currUser.role === USER_ROLE.CONSULTANT
          || this.state.currUser.role === USER_ROLE.OPS || this.state.currUser.role === USER_ROLE.CUSTOMER) {
        url += `&owner=${this.state.currUser.displayName}`
      }
      const res = await axios.get(url )
      if (res && res.data) {
        console.log(res.data)
        const list = res.data.list.map(i => {
          return {
            ...i,
            value: i.id,
            label: `KHTP${i.id} (${i.billupCount || 0})`
          }
        })
        this.setState({listCustomer: list || []})
      }
    } catch (e) {
      console.error(e)
    }
  }

  handlePageChange(pageNumber) {
    if (pageNumber === this.state.data.page) return
    this.getAllCash({page: pageNumber})
  }

  handleDatetoSelect (date) {
    console.log('date ', date)
    this.setState({date})
  }

  checkPermission() {
    try {
      const role = this.state.currUser.role
      if (role === USER_ROLE.ADMIN || role === USER_ROLE.SALER || role === USER_ROLE.CONSULTANT || role === USER_ROLE.MANAGER || role === USER_ROLE.OPS) {
        return true
      }
      return false
    } catch (e) {
    }
  }

  checkPermission2() {
    try {
      const role = this.state.currUser.role
      if (role === USER_ROLE.ADMIN || role === USER_ROLE.SALER || role === USER_ROLE.CONSULTANT || role === USER_ROLE.MANAGER || role === USER_ROLE.OPS) {
        return true
      }
      return false
    } catch (e) {
    }
  }

  isCollector() {
    try {
      const role = this.state.currUser.role
      if (role === USER_ROLE.SHIPPER || role === USER_ROLE.COLLECTOR) {
        return true
      }
      return false
    } catch (e) {
    }
  }

  formatDate = (str) => {
    return moment(str).format('DD/MM/YY HH:mm')
  }

  handleInput = (e) => {
    const { value } = e.target
    this.setState({ search: value })
  }

  onSearch = (e) => {
    this.getAllCash({search: this.state.search})
  }

  searchStatus(val) {
    console.log(val)
    this.setState({qStatus: val})
  }

    searchBy(val) {
    this.setState({searchBy: val})
  }

  searchBylocation(val) {
    this.setState({location: val})
  }

  render() {
    const { data, editCash, createCash, locationOption } = this.state
    
    const statusTypeOption = {
      PENDING: "Chưa thu",
      COLLECTED: "Đã thu",
    }

    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
        />
        <Breadcrumb>
          <BreadcrumbItem>TRANG </BreadcrumbItem>
          <BreadcrumbItem active> Thu Tiền Mặt </BreadcrumbItem>
        </Breadcrumb>
        <Row>
          <Col sm={12} className='ml-auto'>
            <>
              <CardBody>
                <form
                  onSubmit={(e) => {
                    e.preventDefault()
                    this.onSearch()
                  }}
                >
                  <Row className="" style={{gap: "10px"}}>
                    <select className="custom-select" style={{width: '200px', marginRight: '10px'}}
                            onChange={(e) => this.searchStatus(e.target.value)}
                    >
                      <option value="">Tất cả trạng thái</option>
                      <option value="Chưa thu">Chưa thu</option>
                      <option value="Đã thu">Đã thu</option>
                    </select>
                    <div>
                      <Label className="mr-1">Search By: </Label>
                      <select className="custom-select" style={{width: '200px', marginRight: '10px'}}
                              onChange={(e) => this.searchBy(e.target.value)}
                      >
                        <option value="cashId">Cash ID</option>
                        <option value="packageCode">Mã kiện hàng</option>
                      </select>
                    </div>
                    <div>
                      <Label style={{marginRight: '8px'}}>Khu Vực: </Label>
                      <select className="custom-select" style={{width: '200px', marginRight: '10px'}}
                              onChange={(e) => this.searchBylocation(e.target.value)}
                      >
                        <option value="">Tất cả</option>
                        <option value="HCM">HCM</option>
                        <option value="HN">HN</option>
                        <option value="ĐN">ĐN</option>
                      </select>
                    </div>
                    <InputGroup style={{maxWidth: '400px'}}>
                      <Input
                        id="searchInput"
                        style={{minWidth: '150px'}}
                        name="search"
                        value={this.state.search}
                        placeholder='Tìm kiếm...'
                        onChange={this.handleInput}
                      />
                      <Button type="submit" className="btn-search ml-2">Search</Button>
                    </InputGroup>
                  </Row>
                </form>
              </CardBody>
            </>
          </Col>
        </Row>
        <Card style={{marginTop: 20}}>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <span>Danh sách thu tiền mặt</span>
            {this.checkPermission() && (
              <Button type="button" className="butt ml-auto" onClick={this.toggle}>+ Tạo thông tin thu tiền</Button>
            )}
          </CardHeader>
          <CardBody>
            {this.state.loading && (
              <div className="text-center">
                <span className="loader"></span>
              </div>
            )}
            <Table responsive bordered className="mb-0 table-hover">
              <thead>
              <tr>
                <th>#</th>
                <th>Mã Thu Tiền</th>
                <th>Thông tin khách hàng</th>
                <th>Mã kiện hàng</th>
                <th>Số tiền thu</th>
                <th>Thời gian</th>
                <th>Người tạo</th>
                <th>Khu vực</th>
                <th>Trạng Thái</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              {data.list &&
              data.list.map((obj, i) => (
                <tr key={i + 1}>
                  <td>{i + 1}</td>
                  <td><Link to={`/app/cash-detail/${obj.id}`} >CT{obj.id}</Link></td>
                  <td>
                    <p><strong>Name:</strong> {obj.customerName}</p>
                    <p><strong>Phone:</strong> {obj.customerPhone}</p>
                    <p><strong>Address:</strong> {obj.customerAddress}</p>
                  </td>
                  <td>{obj.packageCode}</td>
                  <td>{this.formatNumber(obj.amount)} VNĐ</td>
                  <td>{this.formatDate(obj.date)}</td>
                  <td>{obj.owner}</td>
                  <td>{obj.location}</td>
                  <td className='text-center'>
                    <button className={`text-nowrap btn-status ${obj.statusType ==='Đã thu' ? "btn-success" : "btn-warning"} ${
                      obj.statusType ==='Chưa thu' ? "btn-danger" : ""
                    }`}>{obj.statusType}</button>
                  </td>
                  <td>
                    <div style={{minWidth: '100px'}}>
                      {this.checkPermission() && (
                        <>
                          <Button className="m-1" type="button" color="info" onClick={(e) => this.openEditModal(obj)}>
                            <i className="fas fa-pen"></i>
                          </Button>
                          {this.checkPermission2() && (
                            <Button className="m-1" type="button" color="danger" onClick={(e) => this.onDeleteCash(obj.id)}>
                              <i className="fas fa-trash"></i>
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              </tbody>
            </Table>
          </CardBody>

          <Pagination
            itemClass="page-item"
            linkClass="page-link"
            activePage={data.page}
            itemsCountPerPage={data.size}
            totalItemsCount={data.total}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
            hideFirstLastPages={true}
          />

        </Card>
        <Row>
          {/* Toggle Form Create Cash */}
          <Modal isOpen={this.state.modalToggle} toggle={this.toggle} >
            <Form>
              <ModalHeader toggle={this.toggle}>Tạo thông tin thu tiền</ModalHeader>
              <ModalBody>
                <FormGroup>
                  <Label for="customer">Khách hàng</Label>
                  <Select
                    options={this.state.listCustomer}
                    value={this.state.selectedCustomer[0]?.id}
                    onChange={this.onSelectedCustomer}
                    onInputChange={this.handleInputChange}
                    isSearchable
                    autosize={false}/>
                </FormGroup>
                <FormGroup>
                  <Label for="customerName">Tên Khách Hàng (*)</Label>
                  <Input type="text" name="customerName" value={createCash.customerName} id="customerName" placeholder="Tên khách hàng" onChange={this.onCreateCashChange}/>
                </FormGroup>
                <FormGroup>
                  <Label for="customerAddress">Địa chỉ (*)</Label>
                  <Input type="text" name="customerAddress" value={createCash.customerAddress} id="customerAddress" placeholder="Địa chỉ" onChange={this.onCreateCashChange} />
                </FormGroup>
                <FormGroup>
                  <Label for="customerPhone">Phone (*)</Label>
                  <Input name="customerPhone" id="customerPhone" value={createCash.customerPhone} placeholder="Số điện thoại" onChange={this.onCreateCashChange}/>
                </FormGroup>
                <FormGroup>
                  <Label for="packageCode">Mã kiện hàng (*)</Label>
                  <Input type="text" name="packageCode" id="packageCode" placeholder="Mã kiện hàng" onChange={this.onCreateCashChange} />
                </FormGroup>
                <FormGroup>
                  <Label for="amount">Số tiền thu (*)</Label>
                  <Input type="number" name="amount" id="amount" placeholder="Số tiền thu" onChange={this.onCreateCashChange} />
                </FormGroup>
                <FormGroup className="">
                  <Label for="date" style={{marginRight: '15px'}}>Thời gian thu tiền</Label>
                  <DateTimePicker onChange={this.handleDatetoSelect} value={this.state.date} />
                </FormGroup>
                <FormGroup>
                  <Label for="location">Khu vực</Label>
                  <Input id="location" name="location" type="select" onChange={this.onCreateCashChange} >
                    {Object.values(this.state.locationOption).map((object, i) => <option className="text-capitalize" value={object} key={i}>{object}</option>)}
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label for="statusType">Trạng thái</Label>
                  <Input id="statusType" name="statusType" type="select" onChange={this.onCreateCashChange} >
                    {Object.values(statusTypeOption).map((object, i) => <option className="text-capitalize" value={object} key={i}>{object}</option>)}
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label for="note">Ghi chú</Label>
                  <textarea
                    className="form-control"
                    rows="4"
                    id="note"
                    placeholder="Ghi chú"
                    onChange={this.onCreateCashChange}
                    name="note"
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button type="submit" color="primary" onClick={(e) => this.onCreateCash(e)} >Tạo mới</Button>{' '}
                <Button color="secondary" onClick={this.toggle}>Hủy</Button>
              </ModalFooter>
            </Form>
          </Modal>

          {/* Toggle Form Edit Cash */}
          <Modal isOpen={this.state.modalEditToggle} toggle={this.openEditModal} >
            <Form>
              <ModalHeader toggle={this.openEditModal}>Cập nhật thông tin thu tiền</ModalHeader>
              <ModalBody>
                {
                  this.checkPermission2() && (
                      <div>
                        <FormGroup>
                          <Label for="customer">Khách hàng</Label>
                          <Select
                              options={this.state.listCustomer}
                              value={this.state.selectedCustomer[0]?.id}
                              onChange={this.onSelectedEditCustomer}
                              autosize={false}/>
                        </FormGroup>
                        <FormGroup>
                          <Label for="customerName">Tên Khách Hàng</Label>
                          <Input type="text" name="customerName" value={editCash.customerName} id="customerName" placeholder="Tên khách hàng" onChange={this.onEditCashChange}/>
                        </FormGroup>
                        <FormGroup>
                          <Label for="customerAddress">Địa chỉ</Label>
                          <Input type="text" name="customerAddress" value={editCash.customerAddress} id="customerAddress" placeholder="Địa chỉ" onChange={this.onEditCashChange} />
                        </FormGroup>
                        <FormGroup>
                          <Label for="customerPhone">Phone</Label>
                          <Input name="customerPhone" id="customerPhone" value={editCash.customerPhone} placeholder="Số điện thoại" onChange={this.onEditCashChange}/>
                        </FormGroup>
                        <FormGroup>
                          <Label for="packageCode">Mã kiện hàng</Label>
                          <Input type="text" name="packageCode" id="packageCode" value={editCash.packageCode} placeholder="Mã kiện hàng" onChange={this.onEditCashChange} />
                        </FormGroup>
                        <FormGroup>
                          <Label for="amount">Số tiền thu</Label>
                          <Input type="number" name="amount" id="amount" value={editCash.amount} placeholder="Số tiền thu" onChange={this.onEditCashChange} />
                        </FormGroup>
                        <FormGroup>
                          <Label for="location">Khu vực</Label>
                          <Input id="location" name="location" value={editCash.location} type="select" onChange={this.onEditCashChange} >
                            {Object.values(locationOption).map((object, i) => <option className="text-capitalize" value={object} key={i}>{object}</option>)}
                          </Input>
                        </FormGroup>
                      </div>
                    )
                }
                <FormGroup>
                  <Label for="statusType">Trạng thái</Label>
                  <Input id="statusType" name="statusType" type="select" value={editCash.statusType} onChange={this.onEditCashChange} >
                    {Object.values(statusTypeOption).map((object, i) => <option className="text-capitalize" value={object} key={i}>{object}</option>)}
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label for="note">Ghi chú</Label>
                  <textarea
                    className="form-control"
                    rows="4"
                    id="note"
                    value={editCash.note}
                    placeholder="Ghi chú"
                    onChange={this.onEditCashChange}
                    name="note"
                  />
                </FormGroup>
                {
                  editCash.collectedAt && (
                    <FormGroup>
                      <Label for="collectedAt">Thời gian thu: {this.formatDate(editCash.collectedAt)}</Label>
                    </FormGroup>
                  )
                }
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={(e) => this.onEditCash(e)}>Update</Button>{' '}
                <Button color="secondary" onClick={this.openEditModal}>Cancel</Button>
              </ModalFooter>
            </Form>
          </Modal>

        </Row>
      </div>
    )
  }
}
export default Cash 